import { useState, useEffect, useContext } from "react";
import classes from "./FreightRates.module.css";
import axios from "../../Axios";
import { Urls } from "../../Urls";
import RatesModal from "../Shared/PopupModal/PopupModal";
import { ViewLSP } from "./BenchmarkMasterView/BenchMarkResults/BenchMarkResults";
import { MyCompanyProfileContext } from "../../MyCompanyProfileContext";
import { FaChevronLeft } from "react-icons/fa6";
import CalendlyPopupButton from "../Shared/CalendlyPopupButton/CalendlyPopupButton";
import { CALENDLY_URL } from "../../config/calendly";
import { useExpressInterest } from "../../hooks/useExpressInterest";
import UpgradeModal from "../UpgradeModal/UpgradeModal";

const numberWithCommas = (x) =>
  x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "-";

const MobileBenchmarkResult = ({
  lspLanes,
  currentLaneList,
  allowedrate,
  allowedtransporter,
  resetData,
  onCalendlyScheduled,
}) => {
  const [lanes, setLanes] = useState(lspLanes);
  const [loading, setLoading] = useState(true);
  const [wantsMegaRFQ, setWantsMegaRFQ] = useState(true);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { submitMegaRFQInterest } = useExpressInterest();

  useEffect(() => {
    if (currentLaneList?.length > 0) fetchTransporters();
  }, []);

  const fetchTransporters = () => {
    setLoading(true);
    axios
      .post(`${Urls.benchmarnow}?field=transporter_list`, {
        network: currentLaneList,
        session_created_on: new Date().toISOString(),
      })
      .then((res) => {
        const updated = lspLanes.map((lane) => {
          const match = res.data.network?.find((v) => v.laneKey === lane.laneKey);
          if (!match) return lane;
          const next = {
            ...lane,
            benchmarknow_analysis: { ...lane.benchmarknow_analysis },
          };
          if (match.transporter_dashboard?.transporter_list) {
            next.benchmarknow_analysis.transporter_list =
              match.transporter_dashboard.transporter_list;
          }
          if (
            next.benchmarknow_analysis.dashboard &&
            match.transporter_dashboard?.dashboard
          ) {
            const d = next.benchmarknow_analysis.dashboard.slice();
            d[2] = match.transporter_dashboard.dashboard[0];
            d[3] = match.transporter_dashboard.dashboard[1];
            next.benchmarknow_analysis.dashboard = d;
          }
          return next;
        });
        setLanes(updated);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const expressInterestClick = () => {
    submitMegaRFQInterest({ moduleName: "mobile benchmark", wantsMegaRFQ });
  };

  if (!lanes?.length) return null;

  const laneCountLabel =
    lanes.length > 1 ? `Benchmark result · ${lanes.length} lanes` : "Benchmark result";

  return (
    <div className={classes["mbr-wrapper"]}>
      <button onClick={resetData} className={classes["mbr-back-btn"]}>
        <FaChevronLeft /> {laneCountLabel}
      </button>

      {lanes.map((lane) => {
        const analysis = lane.benchmarknow_analysis;
        const medianRate = analysis?.dashboard?.[0]?.value;
        const transporterCount = analysis?.dashboard?.[3]?.value ?? 0;

        return (
          <div key={lane.laneKey} className={classes["mbr-lane-card"]}>
            <div className={classes["mbr-lane-route-pill"]}>
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="#16b364" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              {lane.origin_name} — {lane.destination_name}
            </div>
            <div className={classes["mbr-lane-truck"]}>{lane.truck_type}</div>

            <div className={classes["mbr-rate-label"]}>Median Contracted Rate</div>
            <div className={classes["mbr-rate-value"]}>
              ₹{numberWithCommas(medianRate)}
            </div>
            <div className={classes["mbr-rate-unit"]}>per full-truckload</div>

            {loading ? (
              <div className={classes["mbr-loading-text"]}>Fetching transporters…</div>
            ) : (
              allowedtransporter === "yes" ? (
                <RatesModal
                  buttonLabel={`View Transporters (${transporterCount})`}
                  buttonClass="btn btn-outline-primary btn-sm"
                  content={<ViewLSP item={analysis} />}
                  title={lane.laneKey}
                  titleSize="sm"
                  id={`mobile_view_transporters_${lane.laneKey}`}
                  size="md"
                  screenName="My Freight Benchmark"
                  variant="popover"
                  moduleName="View LSP"
                  activityName="View LSP Button Clicked"
                />
              ) : (
                <UpgradeModal
                  feature="View Transporter List"
                  screenName="My Freight Benchmark"
                  moduleName="Upgrade Popup"
                  activityName="View Transporters Button Clicked"
                  buttonClass="btn btn-outline-primary btn-sm"
                  buttonLabel={`View Transporters (${transporterCount})`}
                />
              )
            )}
          </div>
        );
      })}

      <div className={classes["mbr-upsell-card"]} style={{ backgroundColor: "#f8fafc", display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* Section 1 */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <div className={classes["mbr-upsell-title"]} style={{ fontSize: "16px", margin: 0 }}>Want to benchmark more lanes?</div>
          <div className={classes["mbr-upsell-text"]} style={{ fontSize: "13px", color: "#475569", margin: 0, lineHeight: "1.5" }}>
            Unlock network-wide freight benchmarks and discover your full savings potential in a 20-minute demo.
          </div>
        </div>

        {/* Separator Line */}
        {/* <div style={{ borderTop: "1px solid #e2e8f0" }}></div> */}

        {/* Section 2 */}
        {/* <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <div className={classes["mbr-upsell-title"]} style={{ fontSize: "16px", margin: 0 }}>Join Mega RFQ</div>
          <div className={classes["mbr-upsell-text"]} style={{ fontSize: "13px", color: "#475569", margin: 0, lineHeight: "1.5" }}>
            Unlock Bigger Savings, Better Service and Greater Sustainability.
          </div>

          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
              userSelect: "none",
              marginTop: "8px",
              fontSize: "14px",
              color: "#475569",
            }}
          >
            <input
              type="checkbox"
              checked={wantsMegaRFQ}
              onChange={(e) => setWantsMegaRFQ(e.target.checked)}
              style={{ display: "none" }}
            />
            <div
              style={{
                width: "20px",
                height: "20px",
                borderRadius: "6px",
                border: wantsMegaRFQ ? "none" : "2px solid #cbd5e1",
                backgroundColor: wantsMegaRFQ ? "#16b364" : "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "12px",
                transition: "all 0.2s ease",
                flexShrink: 0,
              }}
            >
              {wantsMegaRFQ && <i className="fa fa-check" />}
            </div>
            <span>
              I want to know more about <b>Mega RFQs</b>.
            </span>
          </label>
        </div> */}

        <CalendlyPopupButton
          url={CALENDLY_URL}
          text="Express interest →"
          className={classes["mbr-express-btn"]}
          onClick={expressInterestClick}
          triggerPopup={true}
          moduleName="benchmark_results_mobile"
          onCalendlyScheduled={onCalendlyScheduled}
          style={{ marginTop: "8px" }}
        />
      </div>

      <div className={classes["mbr-footer"]}>
        <a
          href="https://lntermsandconditions.blob.core.windows.net/tnc/benchmark_tnc.html"
          rel="noopener noreferrer"
          target="_blank"
        >
          LoRRI Benchmark — Terms of Use &amp; Disclaimers
        </a>
      </div>
    </div>
  );
};

export default MobileBenchmarkResult;